import styled from 'styled-components';
import { colors } from 'themes/colors';

const StyledButton = styled.button`
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #fff;
  background-color: ${colors.primary};
  font-weight: 600;
  padding: 0.5em 2em;
  padding: ${({ padding }) => (padding && padding) || '0.5em 2em'};
  transition: opacity 0.2s;
  cursor: pointer;
  display: inline-block;
  transition: all 0.25s ease 0s;
  border-radius: 3px;

  &:hover {
    opacity: 0.8;
  }
`;

export default StyledButton;



// WEBPACK FOOTER //
// ./src/components/Button/index.js